<div class="tile"
	[ngClass]="sizing"
	[class.no-borders]="noBorders"
	[class.with-header-bar]="headerBar"
	[class.loading]="loading"
	[class.no-padding]="noPadding"
	[class.has-no-content]="noData"
>
	<div class="menu-button" *ngIf="menuOptions" (click)="toggleMenu()" [class.disabled]="loading">
		<i class="fa fa-ellipsis-v"></i>
	</div>
	<ng-content select=".tile-title"></ng-content>
	<bb-hamburger-overlay *ngIf="menuOptions" [options]="menuOptions" (optionSelected)="setMenuFilter($event)"></bb-hamburger-overlay>
	<div class="tile-body">
		<ng-content *ngIf="!noData" select=":not(.tile-title)"></ng-content>
	</div>
	<div class="no-content" *ngIf="noData && !loading && initialised">
		{{ 'NO_DATA_AVAILABLE' | translate }}
	</div>
	<div class="loading-pane" *ngIf="loading || loadingDelayed"></div>
</div>
